import { fetchWithTrace } from '../fetchWithTrace';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export async function getSpeechFromText(text) {
    const { data } = await fetchWithTrace(`${API_URL}/api/tts/getSpeechFromText`, {
        method: 'POST',
        credentials: 'include',
        body: { text }
    });
    return data.audioUrl;
}
